import Vue from 'vue'
import Router from 'vue-router'

import store from '../store'

Vue.use(Router)
let router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/Dashboard',
      name: 'Home',
      component: () => import('@/containers/DefaultContainer'),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '/Table',
          name: 'Table',
          component: () => import('@/views/btable')
        },
        {
          path: '/Dashboard',
          name: 'Dashboard',
          component: () => import('@/views/Dashboard')
        },
        {
          path: '',
          component: () => import('@/views/Dashboard')
        },
        {
          path: '/Profile',
          meta: { label: 'Profile' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/Settings/profile')
            },
            {
              path: 'Edit',
              meta: { label: 'Edit Profile' },
              name: 'EditProfile',
              component: () => import('@/views/Settings/editProfile'),
            },
            {
              path: '/changePassword',
              meta: { label: 'Change Password' },
              name: 'ChangePassword',
              component: () => import('@/views/Profile/changePassword'),
            },
          ]
        },
        {
          path: '/Shops',
          meta: { label: 'Shops' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/Shops/shops'),
            },
            // {
            //   path: 'Edit/:id',
            //   props: true,
            //   meta: { label: 'Edit Shop Details' },
            //   name: 'EditShop',
            //   component: () => import('@/views/users/editUser'),
            // },
            {
              path: 'Add',
              meta: { label: 'Add Shop' },
              name: 'AddShop',
              component: () => import('@/views/Shops/addShop'),
            },
            // {
            //   path: ':id',
            //   props: true,
            //   meta: { label: 'Shop Details' },
            //   name: 'Shop',
            //   component: () => import('@/views/users/user'),
            // },
          ]
        },
        {
          path: '/Products',
          meta: { label: 'Products' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/Products/products'),
            },
            {
              path: 'Search/:searchKey',
              name:'Product Search',
              props:true,
              component: () => import('@/views/Products/search'),
            },
          ]
        },
        {
          path: '/DisabledProducts',
          meta: { label: 'DisabledProducts' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/Products/disabledProducts'),
            },
          ]
        },
        {
          path: '/Items',
          meta: { label: 'Items' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/Items/items'),
            },
            // {
            //   path: 'Edit/:id',
            //   props: true,
            //   meta: { label: 'Edit Item Details' },
            //   name: 'EditItems',
            //   component: () => import('@/views/users/editUser'),
            // },
            {
              path: 'Add',
              meta: { label: 'Add Item' },
              name: 'AddItems',
              component: () => import('@/views/Items/addItems'),
            },
            // {
            //   path: ':id',
            //   props: true,
            //   meta: { label: 'Item Details' },
            //   name: 'Item',
            //   component: () => import('@/views/users/user'),
            // },
          ]
        },
        {
          path: '/Users',
          meta: { label: 'Users' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/Users/users'),
            },
            {
              path: ':id',
                props: true,
                meta: { label: 'User Details' },
                name: 'UserDetails',
              component: () => import('@/views/Users/user'),
            },
            // {
            //   path: 'Edit/:id',
            //   props: true,
            //   meta: { label: 'Edit Category Details' },
            //   name: 'EditCategory',
            //   component: () => import('@/views/Category/editCategory'),
            // },
            // {
            //   path: 'Add',
            //   meta: { label: 'Add Category' },
            //   name: 'AddCategory',
            //   component: () => import('@/views/Category/addCategory'),
            // },
          ]
        },
        {
          path: '/Orders',
          meta: { label: 'Orders' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/Orders/orders'),
            },
            {
              path: ':id',
              props: true,
              meta: { label: 'Order Details' },
              name: 'OrderDetails',
              component: () => import('@/views/Orders/order'),
            },
            // {
            //   path: 'Edit/:id',
            //   props: true,
            //   meta: { label: 'Edit Category Details' },
            //   name: 'EditCategory',
            //   component: () => import('@/views/Category/editCategory'),
            // },
            // {
            //   path: 'Add',
            //   meta: { label: 'Add Category' },
            //   name: 'AddCategory',
            //   component: () => import('@/views/Category/addCategory'),
            // },
          ]
        },
        {
          path: '/Categories',
          meta: { label: 'Categories' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/Category/categories'),
            },
            {
              path: 'Edit/:id',
              props: true,
              meta: { label: 'Edit Category Details' },
              name: 'EditCategory',
              component: () => import('@/views/Category/editCategory'),
            },
            {
              path: 'Add',
              meta: { label: 'Add Category' },
              name: 'AddCategory',
              component: () => import('@/views/Category/addCategory'),
            },
          ]
        },
        {
          path: '/Inventory',
          meta: { label: 'Inventory' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/Inventory/inventory'),
            },
            {
              path: 'Edit/:id',
              props: true,
              meta: { label: 'Edit Product Details' },
              name: 'EditProduct',
              component: () => import('@/views/Inventory/editProduct'),
            },
            {
              path: 'Add',
              meta: { label: 'Add Product' },
              name: 'AddProduct',
              component: () => import('@/views/Inventory/addProduct'),
            },
            {
              path: ':id',
              props: true,
              meta: { label: 'Products' },
              name: 'Products',
              component: () => import('@/views/Inventory/products'),
            },
            {
              path: ':id/:productId',
              props: true,
              meta: { label: 'Product Details' },
              name: 'ProductDetails',
              component: () => import('@/views/Inventory/product'),
            },
          ]
        },
        {
          path: '/Banners',
          meta: { label: 'Banners' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/Banners/banners'),
            },
            {
              path: 'Edit/:id',
              props: true,
              meta: { label: 'Edit Banner Details' },
              name: 'EditBanner',
              component: () => import('@/views/Banners/editBanner'),
            },
            {
              path: 'Add',
              meta: { label: 'Add Banner' },
              name: 'AddBanner',
              component: () => import('@/views/Banners/addBanner'),
            },
          ]
        },
      ],
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/pages/Login')
    },
    {
      path: '/register',
      name: 'Register',
      component: () => import('../views/pages/Register')
    },
    {
      path: '*',
      name: 'NotFound',
      props: true,
      component: () => import('../views/pages/Page404'),
      meta: {
        description: 'App 404 Page',
        requiresAuth: false
      }
    },
    {
      path: '/ServerError',
      name: 'ServerError',
      props: true,
      component: () => import('../views/pages/Page500'),
      meta: {
        description: 'App Server Error Page',
        requiresAuth: false
      }
    },

  ]
})

router.beforeEach((to, from, next) => {
  // if (localStorage.getItem('token')) {
  //   axios({
  //     method: "POST",
  //     url: "/validate/token",
  //     headers: {
  //       "x-auth-token": localStorage.getItem("token")
  //     }
  //   })
  //     .then(response => {
  //       if (!response.data.status) {
  //         localStorage.removeItem("token");
  //         localStorage.removeItem("role");
  //         store.commit("logoutUser");
  //         next({
  //           name: 'Login'
  //         })
  //         return
  //       }
  //     })
  // }
  if (to.matched.some(route => route.meta.requiresAuth) && !store.state.isLoggedIn) {
    next({
      name: 'Login'
    })
    return
  }
  if (to.path === '/login' && store.state.isLoggedIn) {
    next({
      path: '/'
    })
    return
  }
  next()
})

export default router

